import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './agendaItem-report.controller';
import directive from './agendaItem-report.directive';


export default angular.module('app.components.advisory.oversight.agendaItemReport', [
  alerts,
  oversightDataService,
  confirmDialog,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('agendaItemReport', directive)
  .controller('AgendaItemReportController', controller)
  .name;

console.log('app.components.advisory.oversight.agendaItemReport created');
